import React from 'react';

const stack = [
  { label: 'Spring Boot',  color: 'bg-green-500',  category: 'Microservice' },
  { label: '.NET C#',      color: 'bg-green-500',  category: 'Microservice' },
  { label: 'FastAPI',      color: 'bg-blue-500',   category: 'Microservice' },
  { label: 'AI (Ollama)',  color: 'bg-purple-500', category: 'Microservice' },
  { label: 'React UI',     color: 'bg-cyan-500',   category: 'Microservice' },
  { label: 'Nginx Proxy',  color: 'bg-orange-500', category: 'Infra' },
  { label: 'Jenkins',      color: 'bg-red-500',    category: 'CI/CD' },
  { label: 'GitHub',       color: 'bg-gray-600',   category: 'CI/CD' },
  { label: 'Jest / RTL',   color: 'bg-yellow-500', category: 'Testing' },
  { label: 'Portainer',    color: 'bg-teal-500',   category: 'Infra' },
  { label: 'Docker',       color: 'bg-sky-500',    category: 'Infra' },
  { label: 'Raspberry Pi', color: 'bg-pink-500',   category: 'Hardware' },
  { label: 'PostgreSQL',   color: 'bg-indigo-500', category: 'Data' },
];

const categoryColors = {
  'Microservice': 'border-blue-400/40 text-blue-300',
  'Infra':        'border-orange-400/40 text-orange-300',
  'CI/CD':        'border-red-400/40 text-red-300',
  'Testing':      'border-yellow-400/40 text-yellow-300',
  'Hardware':     'border-pink-400/40 text-pink-300',
  'Data':         'border-indigo-400/40 text-indigo-300',
};


export default function Deve() {
  return (
    <section id="hero" className="min-h-screen flex flex-col justify-center px-6 pt-24 pb-16 max-w-5xl mx-auto">

     <p className="text-accent font-body text-sm tracking-[0.2em] uppercase mb-6 animate-fade-up">
        Full Stack · Microservices · CI/CD · AI
      </p>

      <h1 className="font-display text-5xl md:text-7xl text-ink leading-tight mb-6 animate-fade-up animate-delay-100">
        Application stack<br />
        <span className="text-accent italic">on a Pi 4.</span>
      </h1>

      <p className="font-body text-lg text-muted max-w-xl leading-relaxed mb-10 animate-fade-up animate-delay-200">
        A fully self-hosted microservices architecture with AI inference, automated CI/CD pipelines,
        test automation, and container orchestration — running on a Raspberry Pi 4.
      </p>

      {/* Stack pills */}
      <div className="flex flex-wrap gap-2 mb-12 animate-fade-up animate-delay-300">
        {stack.map(({ label, color, category }) => (
          <span
            key={label}
            className={`flex items-center gap-2 text-xs font-body px-3 py-1.5 border rounded-full ${categoryColors[category]}`}
          >
            <span className={`w-1.5 h-1.5 rounded-full ${color}`} />
            {label}
          </span>
        ))}
      </div>

      {/* Legend */}
      <div className="flex flex-wrap gap-4 mb-10 animate-fade-up animate-delay-400">
        {Object.entries(categoryColors).map(([cat, cls]) => (
          <span key={cat} className={`text-xs font-body ${cls}`}>
            ● {cat}
          </span>
        ))}
      </div>

      <div className="flex flex-wrap gap-4 animate-fade-up animate-delay-500">
        <a
          href="#architecture"
          className="px-8 py-3 bg-ink text-cream font-body text-sm tracking-wide hover:bg-accent hover:text-ink transition-all duration-300"
        >
          Architecture
        </a>
        <a
          href="#banking"
          className="px-8 py-3 border border-ink text-ink font-body text-sm tracking-wide hover:border-accent hover:text-accent transition-all duration-300"
        >
          AI Banking
        </a>
        <a
          href="#retail"
          className="px-8 py-3 border border-ink text-ink font-body text-sm tracking-wide hover:border-accent hover:text-accent transition-all duration-300"
        >
          AI Retail
        </a>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
        <div className="w-px h-12 bg-accent/40 mx-auto" />
      </div>
    </section>
  );
}  
 